import { Formik, Field, FormikHelpers } from "formik";
import * as yup from "yup";
import { ButtonPageLayout } from "../common/ButtonPageLayout";
import { Input } from "../common/Input";
import styles from "./CreatePasswordForm.module.scss";
import { useMutation } from "@apollo/client";
import { UPDATE_PASSWORD_WITH_HASH } from "../../apollo/queries";
import { UpdatePasswordWithHash } from "../../apollo/types/updatePasswordWithHash";
import { Navigate, useNavigate, useSearchParams } from 'react-router-dom';

interface CreatePasswordValues {
  password: string;
  confirmPassword: string;
}

const initialFormValues = {
  password: "",
  confirmPassword: "",
};

const validationSchema = yup.object().shape({
  password: yup.string().required(),
  confirmPassword: yup.string().oneOf([yup.ref("password"), null])
});

export const CreatePasswordForm = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hash = searchParams.get("hash")
  const [updatePasswordWithHash] = useMutation<UpdatePasswordWithHash>(UPDATE_PASSWORD_WITH_HASH, {
    onCompleted: () => {
      navigate("/login", { replace: true });
    },
  });

  if(!hash) {
    return <Navigate to='/login'  />
  }

  const updatePassword = (confirmPassword: string) => {
    updatePasswordWithHash({
      variables: {
        updatePasswordWithHashInput: {
          hash,
          password: confirmPassword,
        },
      },
    });
  };

  return (
    <Formik
      initialValues={initialFormValues}
      validationSchema={validationSchema}
      onSubmit={(
        values: CreatePasswordValues,
        { resetForm }: FormikHelpers<CreatePasswordValues>
      ) => {
        const { confirmPassword } = values;
        updatePassword(confirmPassword);
        resetForm();
      }}
    >
      {({ values, handleChange, handleSubmit }) => (
        <form className={styles.formContainer} onSubmit={handleSubmit}>
          <div className={styles.passwordContainer}>
            <Field
              name='password'
              as={Input}
              type='password'
              placeholder='Wachtwoord'
              onChange={handleChange}
              value={values.password}
            />
          </div>
          <div className={styles.confirmPasswordContainer}>
            <Field
              name='confirmPassword'
              as={Input}
              type='password'
              placeholder='Herhaling wachtwoord'
              onChange={handleChange}
              value={values.confirmPassword}
            />
          </div>
          <ButtonPageLayout type='submit'>
            Creëer een wachtwoord
          </ButtonPageLayout>
        </form>
      )}
    </Formik>
  );
};
